<mat-dialog-content class="mat-typography">
    <h2>Ajout d'un type d'équipement</h2>  
    <form class="flex flex-col w-full" [formGroup]="debrisTypeEquipementForm" (ngSubmit)="onFormSubmit()">
        <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
            <mat-form-field class="w-full">
                <mat-label>Débris - Type d'équipement</mat-label>
                <input type="text" matInput formControlName="type">
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
